import { Injectable, OnDestroy } from '@angular/core';
import { Client, IMessage } from '@stomp/stompjs';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

declare const require: any;

@Injectable({ providedIn: 'root' })
export class NotifyService implements OnDestroy {
  private client: Client | null = null;
  readonly messages$ = new Subject<any>();
  readonly count$ = new Subject<number>();
  private unreadCount = 0;

  private activeToken: string | null = null;

  connect(userId: string, token: string): void {
    console.log('[NotifyService] connect() called. userId:', userId, '| token changed:', this.activeToken !== token, '| already active:', !!this.client?.active);
    if (this.client?.active && this.activeToken === token) {
      console.log('[NotifyService] Same token, skipping reconnect.');
      return;
    }
    if (this.client?.active) {
      console.log('[NotifyService] New token detected, disconnecting old connection...');
      this.disconnect();
    }
    this.activeToken = token;
    console.log('[NotifyService] Token preview (first 20):', token?.substring(0, 20));

    this.client = new Client({
      webSocketFactory: () => new (require('sockjs-client'))(`${environment.baseUrl}/nsm/api/v1/notify?userId=${userId}`),
      connectHeaders: { Authorization: `Bearer ${token}` },
      reconnectDelay: 5000,
      debug: (msg) => { if (msg.includes('Authorization') || msg.includes('CONNECT') || msg.includes('SUBSCRIBE')) console.log('[STOMP debug]', msg); },
    });

    this.client.onConnect = () => {
      console.log('[NotifyService] WebSocket connected. Subscribing to /user/queue/notifications');
      this.client!.subscribe('/user/queue/notifications', (frame: IMessage) => {
        const body = JSON.parse(frame.body);
        console.log('[NotifyService] Message received:', body);
        this.messages$.next(body);
        this.unreadCount++;
        this.count$.next(this.unreadCount);
      });
    };

    this.client.onDisconnect = () => console.log('[NotifyService] WebSocket disconnected.');
    this.client.onStompError = (frame) => {
      if (frame.headers['message']?.includes('clientInboundChannel')) return;
      console.error('[NotifyService] STOMP error:', frame.headers['message'], frame.body);
    };
    this.client.onWebSocketError = (event) => console.error('[NotifyService] WebSocket error:', event);

    this.client.activate();
  }

  resetCount(): void {
    this.unreadCount = 0;
    this.count$.next(0);
  }

  setCount(count: number): void {
    this.unreadCount = count;
    this.count$.next(count);
  }

  disconnect(): void {
    this.client?.deactivate();
    this.client = null;
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
